export default __webpack_public_path__ + "static/media/pdf-icon.0c8c9053.png";